import { api } from "@/boot/axios";
import { getAuthToken } from "@/boot/axios";
import type { News } from "@/interfaces";

export function useNews() {

  const getNewsList = async () => {
    try {
      const response = await api.get<News[]>('/news/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return er
    }
  }

  const getNewsDetail = async (newsId: number) => {
    try{
      const response = await api.get<News>(`/news/${newsId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return undefined
    }
  }

  return {
    getNewsList,
    getNewsDetail
  }
}